import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-950 border-t border-background-300/30">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-lg text-background-50"></i>
              </div>
              <span className="text-base font-bold text-foreground-900 font-heading">
                奶水动漫在线
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              免费高清动漫在线观看平台，提供海量动漫资源，涵盖热门番剧、经典动漫、最新连载，随时随地畅享动漫世界。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
              <a href="#quick-links" className="cursor-pointer">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/rexue" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  热血动漫
                </Link>
              </li>
              <li>
                <Link to="/category/lianai" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  恋爱动漫
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
              <a href="#categories" className="cursor-pointer">动漫分类</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/qihuan" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  奇幻冒险
                </Link>
              </li>
              <li>
                <Link to="/category/gaoxiao" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  搞笑日常
                </Link>
              </li>
              <li>
                <Link to="/category/rexue" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  战斗热血
                </Link>
              </li>
              <li>
                <Link to="/category/lianai" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  青春恋爱
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
              <a href="#contact" className="cursor-pointer">联系方式</a>
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line text-primary-500"></i>
                <span>contact@naishuidongman.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-global-line text-primary-500"></i>
                <span>www.naishuidongman.com</span>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/60 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/60 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/60 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-300/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 奶水动漫在线 版权所有 | 本站资源仅供学习交流使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}